import { useMutation } from "@tanstack/react-query";
import { ProviderGroupControllerApi } from "../../../services";
import { getConfigObject } from "../../../utils/utils";

interface Params {
  providerGroup: any;
  xTENANTID?: string;
}

/**
 * query to handle add provider group profile
 * @author Shrinivas Mandhare
 */
export const useAddProviderGroup = () =>
  useMutation({
    mutationFn: async (params: Params) =>
      new ProviderGroupControllerApi(getConfigObject()).createProviderGroup(
        params.providerGroup,
        params.xTENANTID
      ),
  });
